import { useLoaderData } from '@remix-run/react';

export const useLoaderDataSafe = <T,>() => {
  const data = useLoaderData<T>();

  return data || ({} as typeof data);
};
